var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoServiceSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 67,
    viewBox: "0 0 71 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.12 63.9973L12 50.8483L35.12 37.6201L58.16 50.8483L35.12 63.9973Z",
    fill: "url(#paint0_linear_1519_304436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6873 42.5668L34.8438 55.7543V29.3772L57.6873 16.1875V42.5668Z",
    fill: "url(#paint1_linear_1519_304436)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8436 55.7543L12 42.5668V16.1875L34.8436 29.3772V55.7543Z",
    fill: "url(#paint2_linear_1519_304436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8436 29.3772L12 16.1875L34.8436 3L57.6871 16.1875L34.8436 29.3772Z",
    fill: "url(#paint3_linear_1519_304436)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1714 11.3284V16.9688C27.1714 19.336 30.6641 21.2728 34.9724 21.2728C39.2807 21.2728 42.7713 19.336 42.7713 16.9688V11.3284H27.1714Z",
    fill: "url(#paint4_linear_1519_304436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9724 15.8239C39.2808 15.8239 42.7735 13.8979 42.7735 11.5221C42.7735 9.14623 39.2808 7.22021 34.9724 7.22021C30.664 7.22021 27.1714 9.14623 27.1714 11.5221C27.1714 13.8979 30.664 15.8239 34.9724 15.8239Z",
    fill: "url(#paint5_linear_1519_304436)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1875L34.8436 29.3772",
    stroke: "white",
    strokeWidth: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1519_304436",
    x1: 35.1037,
    y1: 70.6315,
    x2: 52.1523,
    y2: 40.7837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1519_304436",
    x1: 34.8438,
    y1: 35.9709,
    x2: 57.6873,
    y2: 35.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1519_304436",
    x1: 12,
    y1: 35.9709,
    x2: 34.8436,
    y2: 35.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1519_304436",
    x1: 29.1321,
    y1: 26.0803,
    x2: 40.555,
    y2: 6.29688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1519_304436",
    x1: 27.1714,
    y1: 16.2995,
    x2: 42.7713,
    y2: 16.2995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1519_304436",
    x1: 32.2738,
    y1: 16.1919,
    x2: 37.6689,
    y2: 6.85007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoServiceSmall);
export default __webpack_public_path__ + "static/media/no_service_small.70bb3ba3fd2300fe1e8cf9a708570ae1.svg";
export { ForwardRef as ReactComponent };